export type SeriesType = 'jumping' | 'dressage' | 'group-dressage' | 'exceptional';

export const getTypeLabel = (type: SeriesType) => {
  switch (type) {
    case "dressage":
      return "Dressuur";
    case "jumping":
      return "Springen";
    case "group-dressage":
      return "Groepsdressuur";
    case "exceptional":
      return "Uitzonderlijke proef";

    default:
      return type;
  }
};
export const getTypeLabelShort = (type: SeriesType) => {
  switch (type) {
    case "dressage":
      return "DR";
    case "jumping":
      return "SP";
    case "group-dressage":
      return "GD";
    case "exceptional":
      return "UITZ";
    default:
      return type;
  }
};

export const getTypeImage = (type: SeriesType) => {
  switch (type) {
    case "exceptional":
    case "dressage":
    case "group-dressage":
      return "/assets/img/dressage.svg";
    case "jumping":
      return "/assets/img/jumping.svg";
  }
};

export const getTypeOrder = (type: SeriesType) => {
  switch (type) {
    case "jumping":
      return 0;
    case "dressage":
      return 1;
    case "group-dressage":
      return 2;
    case "exceptional":
      return 3;
    default:
      return -1;
  }
};
